<template>
  <vs-row>
    <vs-popup
      title="Confirmar Dados do Modelo de Mensagem"
      :active.sync="reviewPopupActive"
      class="sizePopup"
    >
      <vs-card>
        <div slot="header">
          <h3>Configurações Selecionadas</h3>
        </div>
        <div style="font-size: 13px;">
          <p>
            <strong>Título do Modelo de Mensagem:</strong> {{ name }}
          </p>
          <p>
            <strong>Régua de Relacionamento:</strong> {{ relationshipRule ? relationshipRule.name : 'Nenhum selecionado' }}
          </p>
          <p>
            <strong>Canal:</strong> {{ channel ? channel.label : 'Nenhum selecionado' }}
          </p>
          <p v-if="channel !== null && channel.number === 2">
            <strong>Email do Remetente:</strong> {{ (emailsSenders && emailsSenders.length > 0 && emailsSenders[0] && emailsSenders[0].email) ? emailsSenders[0].email : 'Nenhum selecionado' }}
          </p>
          <p v-if="channel !== null && channel.number === 2">
            <strong>Nome da Empresa (nome do remetente):</strong> {{ senderName ? senderName : 'Nenhum selecionado' }}
          </p>
          <p v-if="channel !== null && channel.number === 2">
            <strong>Título do Email:</strong> {{ subject ? subject : 'Nenhum selecionado' }}
          </p>
        </div>
      </vs-card>

      <vs-card>
        <div slot="header">
          <h3>Prévia da Mensagem</h3>
        </div>

        <div style="font-size: 13px;">
          <div style="font-size: 13px;">
            <div style="clear: both;"></div>
            <div class="chat-bubble">
              <div class="message-preview-popup" v-if="message">
                  <p v-html="formattedBodyMessageComputed"></p>
                </div>

              <div class="message-preview-popup" v-if="channel !== null && channel.number === 0">
                <p>Responda apenas <b>NÃO</b> se você deseja parar de receber mensagens via WhatsApp.</p>
              </div>
            </div>
          </div>

          <div style="clear: both;"></div>
        </div>
      </vs-card>

      <div>
        <vs-button class="float-right" @click="create">
          Confirmar
        </vs-button>
      </div>
    </vs-popup>
    <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
      <form id="relationshipTemplateNew" class="form form-vertical" onsubmit="return false">
        <div class="mb-5">
          <div class="header">
            <div class="vx-row mb-6">
              <div class="vx-col w-full">
                <vs-input
                  name="name"
                  v-validate="'required'"
                  class="mb-4 w-full"
                  label-placeholder="Título do Modelo de Mensagem"
                  v-model="name"
                ></vs-input>
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('name')"
                >
                  Informe um valor válido para o Título.
                </span>
              </div>
            </div>

            <div class="mb-8">
              <vs-row>
                <vs-col vs-w="3">
                  <div class="mt-5">
                    <span>Selecione a régua de relacionamento:</span>
                  </div>

                  <v-select
                    class="w-full col" v-model="relationshipRule"
                    :options="relationshipRules" id="id" label="name"
                  >
                    <template #option="{ name }">
                      <div class="name">
                        {{name}}
                      </div>
                    </template>
                  </v-select>
                </vs-col>

                <vs-col vs-w="3" class="ml-5">
                  <div class="mt-5">
                    <span>Selecione o canal:</span>
                  </div>

                  <v-select
                    class="w-full col" v-model="channel"
                    :options="channels" id="number" label="label"
                  >
                    <template #option="{ label }">
                      <div class="name">
                        {{ label }}
                      </div>
                    </template>
                  </v-select>
                </vs-col>

              </vs-row>
            </div>

            <div class="mb-8">
              <div class="mb-8">
                <vs-alert
                  v-if="channel !== null && channel.number === 1"
                  title="Mensagem Inválida"
                  :active="isMessageInvalid(message)"
                  class="mb-8"
                  color="danger"
                  icon="new_releases"
                >
                  Não use acentos em SMS, pois os celulares não conseguem identificar os mesmos.
                </vs-alert>

                <div v-if="channel !== null && channel.number !== 2">
                  <vs-alert
                    v-if="channel && channel.number === 1"
                    title="Atenção!"
                    active="true"
                    class="mb-4 mt-4 h-32"
                    color="warning"
                  >
                  Informamos que nossa política de envio de mensagens de campanhas SMS estabelece um limite máximo de 160 caracteres por mensagem. Ao ultrapassar esse limite, será aplicada uma cobrança adicional a cada intervalo de 160 caracteres excedidos. Por exemplo, se a mensagem atingir 320 caracteres, serão cobrados dois envios.
                  </vs-alert>
                  <label for="wa-message" id="label-wa-message">
                    <strong>Inserir Mensagem</strong>
                  </label>

                  <textarea
                    class="vs-textarea text-area message-text-area"
                    v-model="message"
                    ref="wa-message"
                    id="wa-message"
                  />

                  <div v-if="filteredTagList.length" class="tags-wrapper">
                    <ul>
                      <li v-for="(tag, key) in filteredTagList" :key="`tag-${key}`">
                        <vs-button
                          type="flat"
                          color="primary"
                          @click.stop="insertTagOnText(tag)"
                        >
                          {{tag}}
                        </vs-button>
                      </li>
                    </ul>
                  </div>
                  <div class="flex items-center">
                    <div class="mt-2">
                      <vs-icon v-if="channel !== null && channel.number === 0" class="mr-2 cursor-pointer" @click.prevent="toggleFormat('*')" icon="format_bold" />
                      <vs-icon v-if="channel !== null && channel.number === 0" class="mr-2 cursor-pointer" @click.prevent="toggleFormat('_')" icon="format_italic" />
                      <vs-icon v-if="channel !== null && channel.number === 0" class="mr-2 cursor-pointer" @click.prevent="toggleFormat('~')" icon="format_clear" />
                      <vs-icon v-if="channel !== null && channel.number === 0" class="mr-2 cursor-pointer" @click.prevent="toggleFormat('```')" icon="format_quote" />
                    </div>
                    <span class="text-sm mr-4">Caracteres: {{ message ? message.length : 0 }}</span>
                  </div>
                </div>
              </div>
              <div v-if="channel !== null && channel.number === 2" class="mb-8">
                <div class="w-full flex justify-center items-center">
                  <div class="w-6/12 flex justify-center items-center" style="flex-direction: column;">
                    <div class="w-full flex justify-center items-center">
                      <span class="phone-number-span">Email que Realizará o Envio dos Disparos</span>
                    </div>

                    <v-select
                      class="w-full" v-model="selectedSenderId"
                      :options="processedEmailsSenders"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      :reduce="emailsSenders => emailsSenders.id"
                      label="email"
                    />
                  </div>
                </div>

                <div class="w-full flex justify-center items-center pt-4 pb-4">
                  <div class="w-6/12 flex justify-center items-center" style="flex-direction: column;">
                    <div class="w-full flex justify-center items-center">
                      <span class="phone-number-span">Nome da Empresa (nome do remetente)</span>
                    </div>

                    <vs-input
                      class="w-full"
                      v-model="senderName"
                    />
                  </div>
                </div>

                <div class="w-full flex justify-center items-center pt-4 pb-4">
                  <div class="w-6/12 flex justify-center items-center" style="flex-direction: column;">
                    <div class="w-full flex justify-center items-center">
                      <span class="phone-number-span">Título do Email</span>
                    </div>

                    <vs-input
                      class="w-full"
                      v-model="subject"
                    />
                  </div>
                </div>

                <Vue2Editor
                  @htmlContent="handleHTMLContent"
                  :set-data:="true"
                  @removeTag="tagToReplace = ''"
                  :validateData="updateEmailMessage"
                  :tag="tagToReplace"
                  ref="model-email"
                />

                <div v-if="filteredTagList.length !== 0">
                  <ul class="d-flex">
                    <li v-for="item in filteredTagList">
                      <vs-button
                        type="flat"
                        color="primary"
                        @click="tagToReplace = item"
                      >
                        {{ item }}
                      </vs-button>
                    </li>
                  </ul>
                </div>
              </div>

              <vs-alert
                v-if="channel !== null && channel.number === 1"
                title="Mensagem Inválida"
                :active="isMessageInvalid(message)"
                class="mb-8"
                color="danger"
                icon="new_releases"
              >
                Não use acentos nem emojis em SMS, pois os celulares não conseguem identificar os mesmos.
              </vs-alert>
            </div>
          </div>
        </div>

        <div class="w-full d-flex justify-content-flex-end">
          <vs-button @click.prevent="reviewPopupActiveData">Salvar</vs-button>
        </div>
      </form>
    </vs-col>
  </vs-row>
</template>

<script>
  import requests from '@/http/requests/ruleTemplates'
  import requestsRelationshipRules from '@/http/requests/relationshipRules'
  import requestsRelationshipConditionModels from '@/http/requests/relationshipRuleConditionModels'
  import { formatRouteTenantPath } from '@/utils'
  import vSelect from 'vue-select'
  import emojiRegex from 'emoji-regex';
  import Vue2Editor from "@/components/html/Vue2Editor";
  import moduleCampaignSenderEmail from '@/store/campaignSenderEmail/moduleCampaignSenderEmail'


  export default {
    name: 'relationship-templates-new',
    provide() {
      return {
        $validator: this.$validator,
      }
    },
    components: { 'v-select': vSelect, Vue2Editor },
    computed: {
      formattedBodyMessageComputed() {
        if(this.message){
          let formattedText = this.message;
          formattedText = formattedText
            .replace(/\*(.*?)\*/g, '<strong>$1</strong>')
            .replace(/\_(.*?)\_/g, '<em>$1</em>') 
            .replace(/~(.*?)~/g, '<del style="text-decoration: line-through;">$1</del>') 
            .replace(/```(.*?)```/g, '<code style="font-family: monospace;">$1</code>');

          return formattedText;
        }
        return;
      },
      processedEmailsSenders() {
        if (this.emailsSenders && Array.isArray(this.emailsSenders)) {
          return this.emailsSenders.filter(item => item.status === true).map(
            item => (
              {
                id: item.id,
                email: item.email
              }
            )
          );
        } else {
            return [];
        }
      },
      filteredTagList() {
        return this.tagList.map(item => item.name);
      },
    },
    async mounted() {
      await this.fetchEmails()
      requestsRelationshipRules.fetch().then((response) => {
        this.relationshipRules = response.data.data.getRelationshipRules
      })

      requestsRelationshipConditionModels.fetchWhere(0).then((response) => {
        this.tagList = response.data.data.getRelationshipRuleConditionModels
        this.$store.dispatch('setShowLoadingOverlay', false)
      }).catch((error) => {
        this.$store.dispatch('setShowLoadingOverlay', false)
        console.error(error)
      })
    },
    data() {
      return {
        emailsSenders: [],
        tagToReplace: '',
        subject: null,
        senderName: null,
        selectedSenderId: null,
        updateEmailMessage: false,
        relationshipRules: [],
        reviewPopupActive: false,
        tagList: [],
        channels: [
          {
            number: 0,
            label: 'Whatsapp'
          },
          {
            number: 1,
            label: 'Sms'
          },
          {
            number: 2,
            label: 'Email'
          }
        ],
        channel: null,
        name: '',
        message: '',
        relationshipRule: null,
      }
    },
    created () {},
    methods: {
      reviewPopupActiveData(){
        if (this.channel.number === 2) {
            this.message = this.$refs['model-email'].setValues()
          if(!this.selectedSenderId){
            this.$vs.notify({
              color: 'danger',
              title: 'Erro!',
              text: 'Selecione um Email.'
            });
            return;
          }
          else if(!this.senderName){
            this.$vs.notify({
              color: 'danger',
              title: 'Erro!',
              text: 'Informe um Nome.'
            });
            return;
          }
          else if(!this.subject){
            this.$vs.notify({
              color: 'danger',
              title: 'Erro!',
              text: 'Informe um Título.'
            });
            return;
          }
          else if(!this.message){
            this.$vs.notify({
              color: 'danger',
              title: 'Erro!',
              text: 'Informe uma Mensagem.'
            });
            return;
          }
        }
        if((!this.message && this.channel.number === 0) || (!this.message && this.channel.number === 1)){
          this.$vs.notify({
            color: 'danger',
            title: 'Erro!',
            text: 'Preencha a mensagem.'
          });
          return;
        }
        else if(!this.name){
          this.$vs.notify({
            color: 'danger',
            title: 'Erro!',
            text: 'Preencha o título do modelo de mensagem.'
          });
          return;
        }
        else if (!this.channel) {
          this.$vs.notify({
            color: 'danger',
            title: 'Erro!',
            text: 'Selecione um canal antes de confirmar.'
          });
          return;
        }

        else if (!this.relationshipRule) {
          this.$vs.notify({
            color: 'danger',
            title: 'Erro!',
            text: 'Selecione uma régua de relacionamento antes de confirmar.'
          });
          return;
        }
        this.reviewPopupActive = true
      },
      async fetchEmails() {
        if (!moduleCampaignSenderEmail.isRegistered) {
          this.$store.registerModule('campaignSenderEmail', moduleCampaignSenderEmail)
          moduleCampaignSenderEmail.isRegistered = true
        }
        await this.$store.dispatch("campaignSenderEmail/fetchPaginated", {
          page: 1,
          itemsPerPage: 9999999,
        })

        this.emailsSenders = this.$store.state.campaignSenderEmail.senderEmailData.items
      },
      handleHTMLContent(htmlContent) {
        this.message = htmlContent
      },
      toggleFormat(marker) {
        const textarea = this.$refs['wa-message'];
        const selectedText = textarea.value.substring(textarea.selectionStart, textarea.selectionEnd);
        if (selectedText) {
          if (!this.isFormatted(marker)) {
            const newText = marker + selectedText + marker;
            this.message = this.message.substring(0, textarea.selectionStart) + newText + this.message.substring(textarea.selectionEnd);
          } else {
            this.message = this.message.replace(new RegExp(marker, 'g'), '');
          }
        }
      },
      isFormatted(marker) {
        const textarea = this.$refs['wa-message'];
        const selectedText = textarea.value.substring(textarea.selectionStart, textarea.selectionEnd);
        return selectedText.startsWith(marker) && selectedText.endsWith(marker);
      },
      insertTagOnText(tag) {
        const that = this
        let tArea = this.$refs['wa-message']

        if (!tag) {
          return
        }

        // get cursor's position:
        let startPos = tArea.selectionStart
        let endPos = tArea.selectionEnd
        let cursorPos = startPos
        let tmpStr = tArea.value || ''

        // insert:
        that.message = `${tmpStr.substring(0, startPos)}{{${tag}}}` +
          `${tmpStr.substring(endPos, tmpStr.length)}`

        // move cursor:
        setTimeout(() => {
          cursorPos += that.message.length
          tArea.selectionStart = tArea.selectionEnd = cursorPos
          that.$refs['wa-message'].focus()
        }, 10)
      },
      isMessageInvalid(message) {
        if (message) {
          // Remove all the text tags to not consider accented words inside Tags
          const regex = emojiRegex();
          const containsEmojis = regex.test(message);
          const messageNoTags = message.replace(/{{(.*?)}}/g, '')
          // Search for accented words
          const matches = messageNoTags.normalize('NFD').match(/[\u0300-\u036f]/g) || []

          return containsEmojis || Boolean(matches.length);
        }

        return false
      },
      datePtToEng(date) {
        date = date.split('/')
        return `${date[2]}-${date[1]}-${date[0]}`
      },
      create () {
        this.reviewPopupActive = false
        this.$validator.validateAll().then((valid) => {
          if(!valid) {
            return
          }

          if (this.channel.number === 2) {
            this.message = this.$refs['model-email'].setValues()
          }

          this.$store.dispatch('setShowLoadingOverlay', true)

          let args = {
            name: this.name,
            channel: this.channel.number,
            message: this.message !== null && this.message !== ''
              ? btoa(unescape(encodeURIComponent(this.message)))
              : null,
            relationship_rule_id: this.relationshipRule.id,
            sender_name: this.senderName,
            selected_sender_id: this.selectedSenderId ? this.selectedSenderId : null,
            subject: this.subject,
          }

          this.$store.dispatch('setShowLoadingOverlay', true)

          requests.create(args).then(() => {
            this.$store.dispatch('setShowLoadingOverlay', false);
            this.$vs.notify({
              color: 'success',
              title: 'Sucesso!',
              text: 'O Modelo de Mensagem foi criado com sucesso'
            })
            this.$router.push(formatRouteTenantPath('/messaging/relationship-templates'))
          }).catch((error) => {
            console.log(error)
            this.$vs.notify({
              color: 'danger',
              title: 'Erro!',
              text: 'Erro ao adicionar template'
            })
          })
        }).catch((error) => {
          this.$store.dispatch('setShowLoadingOverlay', false)
          this.$vs.notify({
            color: 'danger',
            title: 'Erro!',
            text: 'Erro ao adicionar template, preencha todos os campos'
          })
          console.log(error)
        })
      }
    },
    beforeRouteLeave(to, from, next) {
      this.reviewPopupActive = false
      setTimeout( ()=> {
        this.reviewPopupActive = false
        next();
      }, 1);
    },
  }
</script>

<style lang="scss">
  #relationshipTemplateNew {
    .body {
      border: none;
      padding: 10px; 
      background: #fff;
      border-radius: 10px;
      box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.090);
    }

    .message-text-area {
      border-bottom-left-radius: 0 !important;
      border-bottom-right-radius: 0 !important;
    }
    .tags-wrapper {
      background-color: #f8f8f8;
      border: 1px solid rgba(0, 0, 0, 0.2);
      border-bottom-left-radius: 6px !important;
      border-bottom-right-radius: 6px !important;
      border-top: none !important;
      > ul > li {
        display: inline-block
      }
    }
    .params-wrapper {
      background-color: #f8f8f8;
      border: 1px solid rgba(0, 0, 0, 0.2);
      border-bottom-left-radius: 6px !important;
      border-bottom-right-radius: 6px !important;
      > ul > li {
        display: inline-block
      }
    }
    .phone-number-span {
      font-size: .7rem;
      cursor: text;
      transition: all .2s ease;
      border-radius: 5px;
      padding: .7rem .7rem .7rem .5rem !important;
      color: rgba(0,0,0,.4);
    }
    .image-items-card {
      width: 100%;
      background: #fff;
      margin-top: 5px;
      border: solid 1px rgba(0, 0, 0, 0.2);
      border-radius: 9px;
    }
    .text-area {
      background: #fff;
      height: 200px;
      border: 1px solid rgba(0, 0, 0, 0.2);
      resize: none !important;
    }
    .align-right {
      float: right;
    }
    .vs-con-table {
      .product-name {
        max-width: 23rem;
      }
      .vs-table--header {
        display: flex;
        flex-wrap: wrap-reverse;
        margin-left: 1.5rem;
        margin-right: 1.5rem;
        > span {
          display: flex;
          flex-grow: 1;
        }
        .vs-table--search{
          padding-top: 0;
          .vs-table--search-input {
            padding: 0.9rem 2.5rem;
            font-size: 1rem;
            &+i {
              left: 1rem;
            }
            &:focus+i {
              left: 1rem;
            }
          }
        }
      }
      .vs-table {
        border-collapse: separate;
        border-spacing: 0 1.3rem;
        padding: 0 1rem;
        tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 10px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
            &.img-container {
              // width: 1rem;
              // background: #fff;
              span {
                display: flex;
                justify-content: flex-start;
              }
              .product-img {
                height: 110px;
              }
            }
          }
          td.td-check{
            padding: 20px !important;
          }
        }
      }
      .vs-table--thead{
        th {
          padding-top: 0;
          padding-bottom: 0;
          .vs-table-text{
            text-transform: uppercase;
            font-weight: 600;
          }
        }
        th.td-check{
          padding: 0 15px !important;
        }
        tr{
          background: none;
          box-shadow: none;
        }
      }
      .vs-table--pagination {
        justify-content: center;
      }
    }
  }
  .message-preview-popup {
    float: right;
    background: #DBF6C5;
    border-radius: .4em;
    clear: both;
    border-bottom: 1px solid rgba(0,0,0,.3);
    max-width: 88%;
    text-align: right;
    padding: 10px;
    > p {
      padding: 0 2px !important;
    }
  }
  .message-preview-popup:not(:last-child) {
    margin-bottom: 10px;
  }
</style>
